<div class="d-flex wrapper d-initial flex-md-column">
    <div class="col-12 g-0 player">
        <app-video
            class="video-player"
            [videoMedia]="video"
            *ngIf="isVideo"
            [muxData]="muxData"
            [gtmVideoJsInfo]="gtmVideoJsInfo"
        ></app-video>
        <div
            *ngIf="!isVideo"
            class="feature-image"
            [ngStyle]="{
                'background-image': 'url(\'' + posterImageURL + '?format=jpg\')',
            }"
        ></div>
    </div>
    <div class="col-12 media-section">
        <div class="media-section-wrapper" [ngStyle]="getColor()">
            <div class="media-section-title">{{ featuredAsset.title }}</div>
            <div class="media-section-description">
                <div
                    class="short-desc"
                    *ngIf="displayShortDescription"
                    [innerHTML]="featuredAsset.description | bypassSecurity: 'html'"
                ></div>
                <div
                    class="long-desc"
                    *ngIf="!displayShortDescription"
                    [innerHTML]="featuredAsset.description | bypassSecurity: 'html'"
                ></div>
            </div>
        </div>
    </div>
</div>
